export const NEW_YEAR_ID = 'NEW_YEAR';
export const WOMAN_DAY_ID = 'WOMAN_DAY';

// Новогодние праздники
const NEW_YEAR = Object.freeze({
    id: NEW_YEAR_ID,
    date: {
        start: '24 Dec',
        end: '16 Jan',
    },
    particlesDrop: false,
    santaRide: true,
    changeParticles: true,
})
// 8 марта
const WOMAN_DAY = Object.freeze({
    id: WOMAN_DAY_ID,
    date: {
        start: '7 Mar',
        end: '8 Mar',
    },
    particlesDrop: true,
})

// Список ивентов
export const eventDates = [ NEW_YEAR, WOMAN_DAY ];
